export const name = "TIME_TRUNC";
export const summary = `Truncates a \`TIME\` value at a particular granularity.`;
export const reference = `
## TIME_TRUNC

Truncates a \`TIME\` value at a particular granularity.

\`\`\`
TIME_TRUNC(time_value, time_granularity)
\`\`\`

### Description

Truncates a \`TIME\` value at a particular granularity.


### Definitions

- \`time_value\`: The \`TIME\` value to truncate.
- \`time_granularity\`: The truncation granularity for a \`TIME\` value. Time granularities can be used.




### Time granularity definitions

- \`MICROSECOND\`: If used, nothing is truncated from the value.

- \`MILLISECOND\`: The nearest lesser than or equal millisecond.

- \`SECOND\`: The nearest lesser than or equal second.

- \`MINUTE\`: The nearest lesser than or equal minute.

- \`HOUR\`: The nearest lesser than or equal hour.


### Details

The resulting value is always rounded to the beginning of \`granularity\`.


### Return Data Type

\`TIME\`


### Example



\`\`\`
SELECT
  TIME "15:30:00" as original,
  TIME_TRUNC(TIME "15:30:00", HOUR) as truncated;

/*----------------------------+------------------------*
 | original | truncated |
 +----------------------------+------------------------+
 | 15:30:00 | 15:00:00 |
 *----------------------------+------------------------*/
\`\`\`




source: https://cloud.google.com/bigquery/docs/reference/standard-sql/time_functions
`;
